export enum AuditCategoryEnum {
  AUTH = 1,
  ADMIN = 2,
  DID = 3,
  FAX = 4,
  FIREWALL = 5,
  RECORDING = 6,
  CALL_LOGS = 7,
  PBX = 8,
  RECORDING_V2 = 9,
  CALL_LOGS_V2 = 10,
}
